import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { PARAM_LABEL_INTERVENTION } from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { Funder } from 'src/app/shared/models/funder';
import { MissionType } from 'src/app/shared/models/mission/mission-type';

@Component({
	selector: 'app-add-mission-type-modal',
	templateUrl: './add-mission-type-modal.component.html',
	styleUrls: ['./add-mission-type-modal.component.scss']
})
export class AddMissionTypeModalComponent implements OnInit {
	NAME_PATTERN = '^[^0-9]+$';

	formEdit = new FormGroup({
		type: new FormControl('', [
			Validators.required,
			Validators.pattern(this.NAME_PATTERN),
			Validators.maxLength(32)
		]),
		isAutoAssignment: new FormControl(true),
		isForExternalService: new FormControl(false),
		isEmployeeExternal: new FormControl(false),
		funder: new FormControl('')
	});

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked = false;

	labelIntervention: string;

	missionType: MissionType;

	funders: Funder[];
	selectedFunder: Funder;

	isFunderActive: boolean;

	constructor(
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private logger: LogService
	) {}

	ngOnInit(): void {
		this.labelIntervention = this.facade.dataStorageService.getLabel(
			PARAM_LABEL_INTERVENTION
		);
		this.missionType = new MissionType();

		this.isFunderActive = this.facade.dataStorageService.isFunderActive();
		if (this.isFunderActive) {
			this.getFunders();
		}
	}

	getFunders() {
		this.facade.funderService.getAllFunders().subscribe({
			next: (funders) => {
				this.funders = funders;
			},
			error: (err) => {
				this.isValidateButtonClicked = false;
				this.facade.toastService.createHttpErrorToast(
					err.error.response ? err.error.response : '',
					err.status
				);
				this.logger.error(err);
			}
		});
	}

	onExternalMissionTypeChange() {
		if (this.formEdit.get('isForExternalService').value) {
			this.formEdit.controls['isAutoAssignment'].setValue(false);
		} else {
			this.formEdit.controls['isAutoAssignment'].setValue(true);
		}
	}

	onSubmit() {
		this.isValidateButtonClicked = true;
		this.missionType.type = this.formEdit.get('type').value;
		this.missionType.forExternalService = this.formEdit.get(
			'isForExternalService'
		).value;
		this.missionType.employeeExternal =
			this.formEdit.get('isEmployeeExternal').value;
		this.missionType.autoAssignment =
			this.formEdit.get('isAutoAssignment').value;
		this.missionType.editable = true;
		this.missionType.funder = this.selectedFunder;

		this.facade.missionTypeService.addMissionType(this.missionType).subscribe({
			next: (succ) => {
				this.bsModalRef.hide();
				// this.isValidateButtonClicked=false;
			},
			error: (err) => {
				this.isValidateButtonClicked = false;
				this.facade.toastService.createHttpErrorToast(
					err.error.response ? err.error.response : '',
					err.status
				);
				this.logger.error(err);
			}
		});
	}

	funderKeyUp(e: any) {
		if (this.selectedFunder && this.selectedFunder.name !== e.value) {
			this.selectedFunder = null;
		}
	}

	typeaheadFunderOnSelect(event: TypeaheadMatch): void {
		this.selectedFunder = event.item as Funder;
		this.formEdit.patchValue({ funder: event.item.name }, { onlySelf: true });
	}

	get type() {
		return this.formEdit.get('type');
	}

	get isAutoAssignment() {
		return this.formEdit.get('isAutoAssignment');
	}

	get isForExternalService() {
		return this.formEdit.get('isForExternalService');
	}

	get isEmployeeExternal() {
		return this.formEdit.get('isEmployeeExternal');
	}

	get funder() {
		return this.formEdit.get('funder');
	}
}
